module.exports = __webpack_public_path__ + "img/avatar2.8660120c.jpg";